import AbstractApiPlatformConnector from '@model-core/connectors/api-platform/AbstractApiPlatformConnector';
import type { Response } from '@model-core/core/AbstractConnector';
import config from '@/config';

/** Connecteur unique vers l'API Teiji (API Platform 4, JSON-LD) */
class ApiConnector extends AbstractApiPlatformConnector {
  getListData(data: Record<string, unknown>): Response['data'] {
    if (Array.isArray(data)) return data;
    return data.member;
  }
}

const apiConnector = new ApiConnector({ baseUrl: config.apiUrl });

export default apiConnector;
